import { IOption } from "../../../../components/inputs/select-dropdown/select-dropdown";
import { NOTE_TYPE } from "../../../../components/note/note";
import { RESOLUTION_ID } from "../../../resolutions/constants";
import { RETURN_METHOD_TYPE } from "../../../return-methods/return-method-types";
import { IReturnMethodNoteData, IReturnMethodPreset } from "../../policy-types";
import PolicyStore from "../policy-store";

class ReturnMethodsPreset {
    private _model: IReturnMethodPreset[] = [] as IReturnMethodPreset[];

    constructor(model: IReturnMethodPreset[]) {
        this._model = model;
    } 

    public getOptionsPreset(policy: PolicyStore): IOption[] {
        const resolution = policy.resolution;
        if (!resolution) {
            return this._model.map(returnMethod => ({
                label: returnMethod.name,
                value: returnMethod.id,
                disabled: false,
            }));
        }

        /** 
         * for manual approval allow all supported return methods, except:
         *  - for instant refund we disable no shipment required
         *  - cancel order does not support any return methods except no shipment required
         * */

        return this._model
            .filter(returnMethod => {

                if (resolution.resolution_id === RESOLUTION_ID.CANCEL_ORDER) {
                    return returnMethod.type === RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED;
                }

                return true;
            })
            .map(returnMethod => {
                let disabled = false;

                if (resolution.resolution_id === RESOLUTION_ID.INSTANT_REFUND) {
                    disabled = returnMethod.type === RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED;
                }
                
                if ([RESOLUTION_ID.DONATE, RESOLUTION_ID.KEEP, RESOLUTION_ID.CANCEL_ORDER].includes(resolution.resolution_id)) {
                    disabled = returnMethod.type !== RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED;
                }

                return {
                    label: returnMethod.name,
                    value: returnMethod.id,
                    disabled: disabled,
                };
            });
    }

    public getPresetById(returnMethodId?: number|null): IReturnMethodPreset|undefined {
        if (!returnMethodId) {
            return;
        }
        return this._model.find(rm => rm.id === returnMethodId);
    }

    public getNoteData(policy: PolicyStore): IReturnMethodNoteData | null{
        if (!policy.returnMethodId) {
            return null;
        }
        const returnMethod = this.getPresetById(policy.returnMethodId);

        // if no return method selected or not "Ship with pre-paid label" type - no need in note
        if (!returnMethod || returnMethod.type !== RETURN_METHOD_TYPE.SHIP_WITH_PRE_PAID_LABEL) {
            return null;
        }

        const aggregatorCode = returnMethod.return_label_setting?.shipping_connection.aggregator_code;

        return {
            type: (!returnMethod.return_label_setting) ? NOTE_TYPE.WARNING : NOTE_TYPE.INFORMATION,
            aggregator: (aggregatorCode) ? policy.aggregatorInfoPreset.getAggregtorLabel(aggregatorCode) : aggregatorCode,
            carrier: returnMethod.return_label_setting?.carrier_code,
            service: returnMethod.return_label_setting?.service_code,
        };
    }
}

export default ReturnMethodsPreset;
